import styled from 'styled-components'
import { useNavigate } from 'react-router-dom'

const Circulation = () => {
    const navigate = useNavigate()

    const handleClickBox = (value) => {
        navigate('./' + value)
    }

    return (
        <MainContainer>
            <Title>流通</Title>
            <ClickBox onClick={e => navigate('./CirculationCheckout')} >
                借書／還書／續借
            </ClickBox>
            <ClickBox onClick={e => navigate('/library/backstage/ManageMARCRecord')} >
                預約
            </ClickBox>
            {false && <>
                <ClickBox onClick={e => handleClickBox('')} >
                    還書
                </ClickBox>
                <ClickBox onClick={e => handleClickBox('')} >
                    續借
                </ClickBox>
                <ClickBox onClick={e => handleClickBox('')} >
                    預約
                </ClickBox>
                <ClickBox onClick={e => handleClickBox('')} >
                    違規管理
                </ClickBox>
            </>}
        </MainContainer>
    )
}

const MainContainer = styled.div`
width: 100%;
display: flex;
justify-content: center;
flex-direction: column;
align-items: center;
padding: 2em;
gap: 0.5em;
`

const ClickBox = styled.div`
padding: 0.2em;
background-color: rgb(221, 241, 249);
border-radius: 0.5em;
width: 10em;
font-size: 1.2em;
cursor: pointer;
`

const ButtonGroup = styled.div`
display: flex;
gap: 1em;
align-items: center;
}
`

const Title = styled.div`
text-align: left;
width: 90%;
font-size: 1.6em;
font-weight: 700;
}
`

export default Circulation